import isPlainObject from 'lodash/isPlainObject'
import isString from 'lodash/isString'
import isNumber from 'lodash/isNumber'

const _encodeBase = (obj, isDecode) => {
  if (!obj) { return obj }

  const newObj = {}
  const codeOptFun =
    isDecode ? decodeURIComponent : encodeURIComponent
  Object.keys(obj).forEach(key => {
    const val = obj[key]
    if (isString(val) && val.length) {
      newObj[key] = codeOptFun(val)
    } else if (isPlainObject(val)) {
      newObj[key] = _encodeBase(val, isDecode)
    } else {
      newObj[key] = val
    }
  })
  return newObj
}

/**
 * 对对象的key编码后返回新的对象
 * @function
 * @param {object} obj
 */
export const encodeObj = (obj) => {
  return _encodeBase(obj)
}

/**
 * 对对象的key解码后返回新的对象
 * @function
 * @param {object} obj
 */
export const decodeObj = (obj) => {
  return _encodeBase(obj, true)
}

/**
 * 将对象的key和val的互换，返回新的对象
 * @function
 * @param {object} obj
 * @returns {object}
 */
export const objReverse = (obj) => {
  if (!isPlainObject(obj)) { return {} }

  const newObj = {}
  Object.keys(obj).forEach(key => {
    const value = obj[key]
    if (isString(value) || isNumber(value)) {
      newObj[value] = key
    }
  })

  return newObj
}

/**
 * 获取对象value组成的数组(因为依赖的是Object.keys，所以顺序不能保证和对象的书写顺序一致)
 * @function
 * @param {object} obj
 */
export const getObjValues = (obj) => {
  if (!isPlainObject(obj)) { return [] }

  const values = []
  Object.keys(obj).forEach((key) => {
    values.push(obj[key])
  })
  return values
}

/**
 * @funciton
 * @param {object} obj
 * @returns {object}
 */
export const clearArrInObj = function (obj) {
  if (isPlainObject(obj)) {
    Object.keys(obj).forEach((key) => {
      obj[key] = clearArrInObj(obj[key])
    })
    return obj
  } else if (Array.isArray(obj)) {
    return []
  }
  return obj
}
